import { render, staticRenderFns } from "./HubFacebookPostPreview.vue?vue&type=template&id=68b5905a&scoped=true&"
import script from "./HubFacebookPostPreview.vue?vue&type=script&lang=js&"
export * from "./HubFacebookPostPreview.vue?vue&type=script&lang=js&"
import style0 from "./HubFacebookPostPreview.vue?vue&type=style&index=0&id=68b5905a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b5905a",
  null
  
)

export default component.exports